import { useMemo } from 'react';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';

export default () => {
  const { breadcrumbs } = useContext(ProductContext);

  return useMemo(() => Array.from(breadcrumbs || []).reverse(), [breadcrumbs]);
};
